import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromDigitalBoard from './digital-board.reducer';
import {DigitalBoardEffects} from './digital-board.effects';
import {DigitalBoardFacade} from './digital-board.facade';
import {DigitalBoardService} from './digital-board.service';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(
			fromDigitalBoard.DIGITAL_BOARD_FEATURE_KEY,
			fromDigitalBoard.reducer
		),
		EffectsModule.forFeature([DigitalBoardEffects])
	],
	providers: [DigitalBoardFacade, DigitalBoardService]
})
export class DigitalBoardStateModule {}
